<template>
  <form-wrapper
    :target="getId"
    :inline="inline"
    :icon="icon"
    :icon-classes="iconClasses"
    :underlined="underlined"
    :label-classes="labelClasses"
    :label="label"
    :error="error"
    :required="required">
    <input
      class="opacity-0 absolute w-0 h-0"
      type="file"
      @change="onChange"
      :id="getId"
      :name="name"
      :accept="accept"
      :multiple="multiple"
      :disabled="disabled"
      :required="required"
      tabindex="-1"
    />
    <label
      :for="getId"
      class="relative cursor-default truncate"
      :class="[fieldClasses, getFieldClasses]"
      :disabled="disabled"
      @keyup.enter="onEnter"
      @focus="onFocus"
      @blur="onBlur"
      tabindex="0"
    >
      <slot :placeholder="getPlaceholder" :preview="preview" :size="getFileSize" :focused="focused">{{ getPlaceholder }}</slot>
    </label>
    <template #label><slot name="label"></slot></template>
    <template #icon><slot name="icon"></slot></template>
    <template #action><slot name="action"></slot></template>
    <template #ending>
      <slot name="extensions" :extensions="accept" />
    </template>
  </form-wrapper>
</template>

<script>
import FormWrapper from "./FormWrapper";

export default {
  components: {
    FormWrapper
  },
  data() {
    return {
      files: [],
      preview: null,
      focused: false
    }
  },
  props: {
    value: [String, Array],
    label: String,
    name: String,
    placeholder: String,
    icon: String,
    fieldClasses: [String, Array],
    labelClasses: [String, Array],
    iconClasses: [String, Array],
    maxFileSize: {
      type: Number,
      default: 5000000
    },
    accept: {
      type: String,
      default: ".doc,.docs,.png,.jpg,.xls,.xlsx,.pdf"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    error: [String, Array],
    underlined: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getPlaceholder() {
      return this.multiple || !this.files.length
        ? this.placeholder
        : this.files[0].name;
    },
    getFieldClasses() {
      return {
        "is-underlined": this.underlined,
        "border-danger focus:border-danger": this.error,
        "has-icon": this.icon,
        "form-field text-left": !this.$slots.default && !this.$scopedSlots.default,
        "is-placeholder": !this.files.length
      };
    },
    getFileSize () {
      return this.files.length ? parseInt(this.files[0].size / 1000) + ' Ko' : ''
    },
    getId() {
      return this.name ? `${this.name}-${this._uid}` : this._uid;
    },
    extensions() {
      return this.accept.replace(/[\[\].]+/g, "").split(",");
    }
  },
  methods: {
    onEnter(event) {
      event.target.click();
    },
    onChange(event) {
      this.files = [...event.target.files].filter(
        file =>
          file.size < this.maxFileSize &&
          this.extensions.includes(this.getFileExtension(file))
      );
      if (this.files.length) {
        this.$emit("file-change", this.multiple ? this.files : this.files[0]);
      } else {
        this.$emit("file-change", this.multiple ? [] : null);
      }

      if (this.files.length !== event.target.files.length) {
        alert("Fichier trop volumineux ou extension non supportée");
      }

      this.getPreview()
    },
    getPreview (file) {
      if (this.files.length === 1) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.preview = e.target.result
        }
        reader.readAsDataURL(this.files[0])
      } else {
        this.preview = null
      }
    },
    getFileExtension(file) {
      return file.name.split(".").pop();
    },
    onFocus () {
      this.focused = true
    },
    onBlur () {
      this.focused = false
    }
  }
};
</script>
